import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React, { useRef, useEffect } from 'react';
import { SubNav } from '@primer/react';
import { isEnterOrSpacePressed, focusTabOnArrow } from '../../utils/functions.js';

var LTSubnav = function LTSubnav(_a) {
  var _b = _a.ariaLabel,
    ariaLabel = _b === void 0 ? undefined : _b,
    _c = _a.extraStyles,
    extraStyles = _c === void 0 ? {} : _c,
    _d = _a.handleClick,
    handleClick = _d === void 0 ? function () {} : _d,
    _e = _a.listItems,
    listItems = _e === void 0 ? [] : _e,
    _f = _a.selectedItem,
    selectedItem = _f === void 0 ? "" : _f;
    _a.tabPanelId;
    var rest = __rest(_a, ["ariaLabel", "extraStyles", "handleClick", "listItems", "selectedItem", "tabPanelId"]);
  var subNavRef = useRef([]);
  useEffect(function () {
    var navElement = document.getElementsByClassName("SubNav-body")[0];
    // Check if the nav element exists
    if (navElement) {
      navElement.setAttribute("role", "tablist");
      navElement.setAttribute("aria-orientation", "horizontal");
    }
  }, []);
  return /*#__PURE__*/React.createElement(SubNav, {
    "aria-label": ariaLabel
  }, /*#__PURE__*/React.createElement(SubNav.Links, null, listItems.map(function (item, index) {
    var _a = item || {},
      _b = _a.contentId,
      contentId = _b === void 0 ? "" : _b,
      customDom = _a.customDom,
      _c = _a.name,
      name = _c === void 0 ? "" : _c,
      _d = _a.value,
      value = _d === void 0 ? "" : _d,
      _e = _a.id,
      id = _e === void 0 ? "" : _e;
    return /*#__PURE__*/React.createElement(SubNav.Link, __assign({
      "aria-controls": selectedItem === value ? "subnav-".concat(contentId) : undefined,
      "aria-selected": selectedItem === value,
      id: id,
      key: "".concat(name, "-").concat(index),
      onClick: function onClick() {
        return handleClick(item);
      },
      onKeyDown: function onKeyDown(e) {
        if (isEnterOrSpacePressed(e)) {
          handleClick(item);
        } else {
          var lastIndex = listItems.length - 1;
          focusTabOnArrow(e, "horizontal", subNavRef, index, lastIndex);
        }
      },
      ref: function ref(el) {
        return subNavRef.current[index] = el;
      },
      role: "tab",
      selected: selectedItem === value,
      sx: __assign({
        borderColor: "border.default",
        color: "fg.default",
        cursor: "pointer",
        "&.selected": {
          color: "fg.default",
          backgroundColor: "#D0D7DE66",
          borderColor: "border.default"
        },
        "&:focus-visible": {
          outline: "2px solid",
          outlineOffset: "-1px",
          outlineColor: "focus.outlineColor"
        }
      }, extraStyles),
      tabIndex: selectedItem === value ? 0 : -1
    }, rest), /*#__PURE__*/React.createElement("span", null, name), customDom && customDom);
  })));
};

export { LTSubnav as default };
